import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { ref: "rootElement" };
const _hoisted_2 = {
    key: 0,
    class: "opPaginationContainer top"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("option", { value: 10 }, "10", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("option", { value: 25 }, "25", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("option", { value: 50 }, "50", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("option", { value: 100 }, "100", -1);
const _hoisted_7 = [
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    class: "opTable",
    ref: "tableRoot"
};
const _hoisted_10 = {
    key: 1,
    class: "opPaginationContainer bottom"
};
const _hoisted_11 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showUpperPagination)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("select", {
                    class: "opItemsPerPage",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.itemsPerPage) = $event))
                }, _hoisted_7, 512), [
                    [_vModelSelect, _ctx.itemsPerPage]
                ]),
                _createElementVNode("div", {
                    class: "opPaginationNumber",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
                }, " < "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["opPaginationNumber", { selected: _ctx.selectedPage == i }]),
                        key: i,
                        onClick: ($event) => (_ctx.setSelectedPage(i))
                    }, _toDisplayString(i), 11, _hoisted_8));
                }), 128)),
                _createElementVNode("div", {
                    class: "opPaginationNumber",
                    onClick: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.addPage && _ctx.addPage(...args)))
                }, " > ")
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_9, [
            _renderSlot(_ctx.$slots, "default", { data: _ctx.paginated })
        ], 512),
        (_ctx.showLowerPagination)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                    class: "opPaginationNumber",
                    onClick: _cache[3] || (_cache[3] =
                        //@ts-ignore
                        (...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
                }, " < "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["opPaginationNumber", { selected: _ctx.selectedPage == i }]),
                        key: i,
                        onClick: ($event) => (_ctx.setSelectedPage(i))
                    }, _toDisplayString(i), 11, _hoisted_11));
                }), 128)),
                _createElementVNode("div", {
                    class: "opPaginationNumber",
                    onClick: _cache[4] || (_cache[4] =
                        //@ts-ignore
                        (...args) => (_ctx.addPage && _ctx.addPage(...args)))
                }, " > ")
            ]))
            : _createCommentVNode("", true)
    ], 512));
}
